
<div class="flow-dag-chart-wrapper">
	<div v-if="showControls" class="flow-dag-chart-controls">
		<div v-if="$slots['controls']" class="flow-dag-chart-custom-controls">
			<slot name="controls" />
		</div>
		<Icon
			v-tooltip="{
				content: '<span class=\'fc-dark paragraph-2\'>Reset</span>',
				placement: 'bottom',
				classes: ['black']
			}"
			name="reload"
			type="outlined"
			:disabled="!enableReset"
			size="small"
			@click="reset()"
		/>
		<Icon name="vert-line" type="outlined" :disabled="true" size="small" class="margin-lt-12" />
		<Icon
			v-tooltip="{
				content: '<span class=\'fc-dark paragraph-2\'>Zoom in</span>',
				placement: 'bottom',
				classes: ['black']
			}"
			name="i-plus"
			type="filled"
			size="small"
			class="margin-lt-12"
			@click="zoomIn()"
		/>
		<Icon
			v-tooltip="{
				content: '<span class=\'fc-dark paragraph-2\'>Zoom out</span>',
				placement: 'bottom',
				classes: ['black']
			}"
			name="minus"
			type="outlined"
			size="small"
			class="margin-lt-24"
			@click="zoomOut()"
		/>
	</div>
	<div :id="id" class="flow-dag-chart" />
</div>
